<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between">
                <div>
                    <el-row>
                        <el-col :span="4">
                            <el-select v-if = "pharmacyShow" v-model="query.pharmacyId" size="small" placeholder="选择药房" style="width: 120px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in pharmacies" :key="item.id"
                                        :label="item.name" :value="item.id"></el-option>
                           </el-select>

                        </el-col>
                        <el-col :span="5">
                           <el-input v-model="query.medicinalName"
                              size="small"
                              placeholder="药品名称/通用名"
                              suffix-icon="el-icon-search">
                            </el-input>

                        </el-col>

                        <el-col :span="4">
                            <el-select v-model="query.medicinalType" size="small" style="margin-left: 20px">
                                <el-option key="KE_LI" label="中药颗粒" value="KE_LI"></el-option>
                                <el-option key="YING_PIAN" label="中药饮片" value="YING_PIAN"></el-option>
                                <el-option key="GAO_FANG" label="中药膏方" value="GAO_FANG"></el-option>
                                <el-option key="WAN_JI" label="中药丸剂" value="WAN_JI"></el-option>
                                <el-option key="FU_LIAO" label="辅料" value="FU_LIAO"></el-option>
                            </el-select>

                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="query.medicineStatus" size="small" style="width: 120px;margin-left: 20px">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option key="SHELF" label="已上架" value="SHELF"></el-option>
                                <el-option key="OBTAINED" label="已下架" value="OBTAINED"></el-option>
                            </el-select>
                            
                        </el-col>
                   
                        <el-col :span="3" style="text-align: center;">
                            <el-button type="primary" @click="search" style="width: 68px">查询</el-button>
                        </el-col> 
                         <el-col :span="4">
                             <el-button type="primary" @click="openAdd" style="width: 68px">新增</el-button>

                         </el-col>
                    </el-row>
                </div>
                <div style="display:flex">
                   <el-button size="small" style="width: 96px;float:right;margin-right:10px" @click="excelExport">下载模板</el-button> 
                   <el-button size="small" style="width: 96px;" @click="dataExport">批量导出</el-button>                    
                   <el-upload
                    style="display: inline-block; margin-left:10px;margin-right:10px;width:96px;float:right;" 
                    action=""
                    :multiple="false"
                    :limit=1                    
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :show-file-list="false"
                    :drag="false"
                    :http-request="uploadFile"
                    ref="excel"
                    >
                    <el-button size="small" style="width: 96px;float:left">批量导入</el-button>                    
                    </el-upload> 
                                 
                    
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
                    <el-table-column label="药品剂型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.productSubType === 'KE_LI'">颗粒</span>
                            <span v-else-if="scope.row.productSubType === 'YING_PIAN'">饮片</span>
                            <span v-else-if="scope.row.productSubType === 'GAO_FANG'">膏方</span>
                            <span v-else-if="scope.row.productSubType === 'WAN_JI'">丸剂</span>
                            <span v-else-if="scope.row.productSubType === 'FU_LIAO'">辅料</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="药品名称" prop="productName"></el-table-column>
                    <el-table-column label="通用名" prop="productPharmacyName"></el-table-column>
                    <el-table-column label="单位" prop="quantityUnit">                                 
                    </el-table-column>
                    <el-table-column label="零售单价" prop="price"></el-table-column>
                    <el-table-column label="库存" prop="quantity"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 'SHELF'">已上架</span>
                            <span v-else-if="scope.row.status === 'OBTAINED'">已下架</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicinal(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.status === 'OBTAINED'" type="text" @click="changeStatus(scope.row)">上架</el-button>
                            <el-button v-else-if="scope.row.status === 'SHELF'" type="text" @click="changeStatus(scope.row)">下架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="740px" :close-on-click-modal="false">
           
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                <div class="dialog-set">
                    <el-form-item label="药品剂型:" prop="productSubType">             
                     
                       <el-radio-group v-model="medicinalAdd.productSubType">
                            <el-radio label="KE_LI">中药颗粒</el-radio>
                            <el-radio label="YING_PIAN">中药饮片</el-radio>
                            <el-radio label="GAO_FANG">中药膏方</el-radio>
                            <el-radio label="WAN_JI">中药丸剂</el-radio>
                           <el-radio label="FU_LIAO">辅料</el-radio>
                        </el-radio-group>
                   </el-form-item>
                </div>
                <div class="dialog-set">
                  <el-form-item label="药房对应编码:" prop="materialsCode">
                        <el-input v-model="medicinalAdd.materialsCode" style="width: 240px">                            
                        </el-input>
                         <el-checkbox v-model="medicinalAdd.auto">自动</el-checkbox>
                 </el-form-item>
                 
                </div>
                <div class="dialog-set">

                    <el-form-item label="药品名称:" prop="productName">
                        <el-input v-model="medicinalAdd.productName" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="通用名:" prop="productPharmacyName">
                        <el-input v-model="medicinalAdd.productPharmacyName" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                 <div class="dialog-set">

                     <el-form-item label="拼音简码:" prop="productPrefix">
                        <el-input v-model="medicinalAdd.productPrefix" style="width: 240px"></el-input>
                    </el-form-item>
                     <el-form-item label="拼音全拼:" prop="productPinyin">
                        <el-input v-model="medicinalAdd.productPinyin" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                
                 <div class="dialog-set">  
                    <el-form-item label="药品单位:" prop="quantityUnit">
                        <el-select v-model="medicinalAdd.quantityUnit" size="small" style="width: 115px" placeholder="药品单位">
                            <el-option key="1" label="克" value="KE"></el-option>
                            <el-option key="2" label="袋" value="DAI"></el-option>
                            <el-option key="3" label="条" value="TIAO"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="unitWeight" v-if="medicinalAdd.quantityUnit === 'DAI'">
                        <el-input v-model="medicinalAdd.unitWeight" style="width: 115px">
                            <span slot="suffix">克/袋</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="unitWeight" v-if="medicinalAdd.quantityUnit === 'TIAO'">
                        <el-input v-model="medicinalAdd.unitWeight" style="width: 115px">
                            <span slot="suffix">克/条</span>
                        </el-input>
                    </el-form-item>
                  
                 </div>
                 <div class="dialog-set">
                    <el-form-item label="采购单价:" prop="purchasePrice">
                        <el-input v-model="medicinalAdd.purchasePrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="price">
                        <el-input v-model="medicinalAdd.price" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="quantity">
                        <el-input v-model="medicinalAdd.quantity" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="minQuantity">
                        <el-input v-model="medicinalAdd.minQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>

       
        <el-dialog title="编辑药材" :visible.sync="dialogEditVisible" width="740px" :close-on-click-modal="false">
            
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                 <div class="dialog-set">
                    <el-form-item label="药品剂型:" prop="productSubType" >             
                     
                       <el-radio-group v-model="medicinalEdit.productSubType">
                            <el-radio label="KE_LI" v-if="medicinalEdit.productSubType=='KE_LI'">中药颗粒</el-radio>
                            <el-radio label="YING_PIAN" v-if="medicinalEdit.productSubType=='YING_PIAN'">中药饮片</el-radio>
                            <el-radio label="GAO_FANG" v-if="medicinalEdit.productSubType=='GAO_FANG'">中药膏方</el-radio>
                            <el-radio label="WAN_JI" v-if="medicinalEdit.productSubType=='WAN_JI'">中药丸剂</el-radio>
                            <el-radio label="FU_LIAO" v-if="medicinalEdit.productSubType=='FU_LIAO'">辅料</el-radio>
                        </el-radio-group>
                   </el-form-item>
                </div>
                <div class="dialog-set">

                    <el-form-item label="药品名称:" prop="productName">
                        <el-input v-model="medicinalEdit.productName" :disabled="true" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="通用名:" prop="productPharmacyName">
                        <el-input v-model="medicinalEdit.productPharmacyName" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                 <div class="dialog-set">

                     <el-form-item label="拼音简码:" prop="productPrefix">
                        <el-input v-model="medicinalEdit.productPrefix" style="width: 240px"></el-input>
                    </el-form-item>
                     <el-form-item label="拼音全拼:" prop="productPinyin">
                        <el-input v-model="medicinalEdit.productPinyin" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
                
                 <div class="dialog-set">  
                    <el-form-item label="药品单位:" prop="quantityUnit">
                        <el-select v-model="medicinalEdit.quantityUnit" size="small" style="width: 115px" placeholder="药品单位">
                            <el-option key="1" label="克" value="KE"></el-option>
                            <el-option key="2" label="袋" value="DAI"></el-option>
                            <el-option key="3" label="条" value="TIAO"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="unitWeight" v-if="medicinalEdit.quantityUnit === 'DAI'">
                        <el-input v-model="medicinalEdit.unitWeight" style="width: 115px">
                            <span slot="suffix">克/袋</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="unitWeight" v-if="medicinalEdit.quantityUnit === 'TIAO'">
                        <el-input v-model="medicinalEdit.unitWeight" style="width: 115px">
                            <span slot="suffix">克/条</span>
                        </el-input>
                    </el-form-item>
                 </div>
                 <div class="dialog-set">
                    <el-form-item label="采购单价:" prop="purchasePrice">
                        <el-input v-model="medicinalEdit.purchasePrice" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="零售价格:" prop="price">
                        <el-input v-model="medicinalEdit.price" style="width: 240px">
                            <span slot="suffix">元</span>
                        </el-input>
                    </el-form-item>
                </div>
                
                <div class="dialog-set">
                    <el-form-item label="库存:" prop="quantity">
                        <el-input v-model="medicinalEdit.quantity" style="width: 240px"></el-input>
                    </el-form-item>
                    <el-form-item label="库存下限:" prop="minQuantity">
                        <el-input v-model="medicinalEdit.minQuantity" style="width: 240px"></el-input>
                    </el-form-item>
                </div>
            </el-form>
           
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {
        
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {
                    pharmacyId:'',
                    medicineStatus: '',
                    medicinalType: 'KE_LI',                   
                },
                pharmacyShow:true,
                pharmacies:[],
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],
                
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    productName:[{required: true, message: '请输入药品名称', trigger: 'blur'}],                    
                    quantityUnit: [{required: true, message: '请选择药品单位', trigger: 'change'}],
                    productSubType: [{required: true, message: '请选择药品剂型', trigger: 'change'}],                   
                    price: [{required: true, message: '请输入药品零售价', trigger: 'blur'}],                    
                },
                medicinalAdd: {
                    materialsCode:'',
                    auto:false,
                    // 药品剂型 颗粒饮片1
                    productSubType:'',                   
                    // 药品名称1
                    productName: '',
                    // 药品通用名1
                    productPharmacyName: '',
                    // 药品简码1
                    productPrefix: '',
                    productPinyin: '',
                    // 单位1
                    quantityUnit: '',
                    unitWeight: '',                    
                    // 药品进价
                    purchasePrice: '',
                    // 零售价
                    price: '',
                    // 药品库存
                    quantity: '',
                    // 药品库存下限
                    minQuantity: '',
                },
               
                dialogEditVisible: false,
                medicinalEdit: {
                    // 药品剂型 颗粒饮片1
                    pharmacyNo:'',
                    productNo :'',
                    stockNo:'',
                    productSubType:'',                   
                    // 药品名称1
                    productName: '',
                    // 药品通用名1
                    productPharmacyName: '',
                    // 药品简码1
                    productPrefix: '',
                    productPinyin: '',
                    // 单位1
                    quantityUnit: '',
                    unitWeight: '',                    
                    // 药品进价
                    purchasePrice: '',
                    // 零售价
                    price: '',
                    // 药品库存
                    quantity: '',
                    // 药品库存下限
                    minQuantity: '',
                }
            }
        },

        methods: {
            getParams(){
                // 取到路由带过来的参数
                const routerParams = this.$route.query.pharmacyId
                // 将数据放在当前组件的数据内                
                
                this.query.pharmacyId = parseInt(routerParams)
                if(routerParams){             
                      
                    this.pharmacyShow = false                    
                }else{
                    this.query.pharmacyId = ''
                }                
                
            },
            search(){
                this.getData();
            },
            // 获取列表数据
            getData() {
                               
                this.loading = true
                let params = {
                    pharmacyId: this.query.pharmacyId,
                    medicineStatus: this.query.medicineStatus,
                    medicinalType: this.query.medicinalType,
                    medicinalName: this.query.medicinalName,
                }
                console.log(params.pharmacyId)
                this.axios.post('/api-b/10031/100084/' + this.pageNum + '/' + this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                            
                        } else {
                            this.$message.info('暂无药材')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
                
            },
            getPharmacy() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('/api-b/10008/100088',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.pharmacies = res.data.data.list
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true

                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                    this.medicinalAdd.productSubType = this.query.medicinalType
                })
            },
    
           
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}
                        
                        params = {
                            pharmacyId:this.query.pharmacyId,
                            materialsCode:this.medicinalAdd.materialsCode,
                            auto:this.medicinalAdd.auto,
                            
                            productSubType:this.medicinalAdd.productSubType,                   
                            // 药品名称1
                            productName: this.medicinalAdd.productName,
                            // 药品通用名1
                            productPharmacyName: this.medicinalAdd.productPharmacyName,
                            // 药品简码1
                            productPrefix: this.medicinalAdd.productPrefix,
                            productPinyin: this.medicinalAdd.productPinyin,
                            // 单位1
                            quantityUnit: this.medicinalAdd.quantityUnit,
                            unitWeight: this.medicinalAdd.unitWeight,                    
                            // 药品进价
                            purchasePrice: this.medicinalAdd.purchasePrice,
                            // 零售价
                            price: this.medicinalAdd.price,
                            // 药品库存
                            quantity: this.medicinalAdd.quantity,
                            // 药品库存下限
                            minQuantity: this.medicinalAdd.minQuantity,
                        }
                           
                        this.axios.post('/api-b/10031/100085/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            
            // 获取药材详情,打开编辑
            editMedicinal(data) {
                let params = new FormData()
                params.append('stockNo',data.stockNo)
                this.axios.post('/api-b/10031/100087/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data                   
                        this.dialogEditVisible = true                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })              
            },
          
            // 确认编辑
            confirmEdit() {
                
                let params = {}
                        
                params = {
                    pharmacyNo:this.medicinalEdit.pharmacyNo,
                    productNo :this.medicinalEdit.productNo,
                    stockNo:this.medicinalEdit.stockNo,
                    status:this.medicinalEdit.status,
                    productSubType:this.medicinalEdit.productSubType,                   
                    // 药品名称1
                    productName: this.medicinalEdit.productName,
                    // 药品通用名1
                    productPharmacyName: this.medicinalEdit.productPharmacyName,
                    // 药品简码1
                    productPrefix: this.medicinalEdit.productPrefix,
                    productPinyin: this.medicinalEdit.productPinyin,
                    // 单位1
                    quantityUnit: this.medicinalEdit.quantityUnit,
                    unitWeight: this.medicinalEdit.unitWeight,                    
                    // 药品进价
                    purchasePrice: this.medicinalEdit.purchasePrice,
                    // 零售价
                    price: this.medicinalEdit.price,
                    // 药品库存
                    quantity: this.medicinalEdit.quantity,
                    // 药品库存下限
                    minQuantity: this.medicinalEdit.minQuantity,
                }
                this.axios.post('/api-b/10031/100086/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 药材上下架
            changeStatus(data){
                const h = this.$createElement;
                let msg  = '';
                if (data.status === 'SHELF') {
                    msg = '确定要下架该药材吗？'
                } else {
                    msg = '确定要上架该药材吗？'
                }
                this.$msgbox({               
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, msg),
                        ])
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    
                let params = {
                    pharmacyNo: data.pharmacyNo,
                    productNo: data.productNo,                    
                }
                if (data.status === 'SHELF') {
                    params.status = 'OBTAINED'
                } else {
                    params.status = 'SHELF'
                }
                this.axios.post('/api-b/10031/100134',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000){
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                    }).catch(error => {})
                })            

            },
            excelExport(){
               this.axios.get('/api-b/10031/100212',{
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },
        uploadFile(item){
            
            let params = new FormData()
            params.append('file',item.file)
            params.append('pharmacyId',this.query.pharmacyId)
            this.axios.post('/api-b/10031/100214',params,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
            }).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.getData()                        
                } else {
                    this.$message.error(res.data.message)
                }
            })

        },
        dataExport(){
              
               this.axios.get('/api-b/10031/100216',{
                    params:{
                       pharmacyId: this.query.pharmacyId,
                       medicineStatus: this.query.medicineStatus,
                       medicinalType: this.query.medicinalType,
                       medicinalName: this.query.medicinalName, 
                    },
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },


        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            },
            '$route': 'getParams'
        },
        created() {
            this.getPharmacy() 
            this.getData()
            this.getParams()
            
        }
    }
    function revertUTF8(szInput) {
    var x,wch,wch1,wch2,uch="",szRet="";
    for (x=0; x<szInput.length; x++) {
        if (szInput.charAt(x)=="%") {
            wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
            if (!wch) {break;}
            if (!(wch & 0x80)) {
                wch = wch;
            } else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x1F)<< 6;
                wch1 = wch1 & 0x3F;
                wch  = wch + wch1;
            } else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x0F)<< 12;
                wch1 = (wch1 & 0x3F)<< 6;
                wch2 = (wch2 & 0x3F);
                wch  = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        } else {
            szRet += szInput.charAt(x);
        }
    }
    return(szRet);
}
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
.inline-block {
  display: inline-block;
  
}
</style>